<div class="container">
  <h1 class="rounded text-center">Add {{type}}</h1>

  <!-- ✅ Show context information -->
  <div *ngIf="isInventorySubtype && category" class="text-center mb-3">
    <small class="text-muted">Adding to category: <strong>{{ category }}</strong></small>
  </div>

  <form [formGroup]="form" class="text-center">
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Enter Name</mat-label>
        <input matInput type="text" formControlName="name" #inputField>
        <mat-error *ngIf="Name?.invalid && (Name?.touched || Name?.dirty)">
          <span style="color: red;" *ngIf="Name?.errors?.required">*It is Required.</span>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="d-flex justify-content-center gap-3 mt-3">
      <!-- SUBMIT BUTTON -->
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="Submit()"
        [disabled]="form.invalid">
        Submit
      </button>

      <!-- CANCEL BUTTON -->
      <button
        mat-raised-button
        color="warn"
        type="button"
        (click)="onCancel()">
        Cancel
      </button>
    </div>
  </form>
</div>
